(function() {
    'use strict';

    angular.module('vobeApp').factory('TermsService', TermsService);

    TermsService.$inject = ['$resource'];

    function TermsService($resource) {
        var service = $resource(
            'api/terms',
            {},
            {
                query: { method: 'GET', isArray: false },
                get: {
                    method: 'GET',
                    transformResponse: function(data) {
                        if(!data || (typeof data === 'string' && data.length==0)){
                            return data;
                        }
                        data = angular.fromJson(data);
                        return data;
                    }
                }
            }
        );

        return service;
    }
})();
